import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/user`;

export const userService = {
    async createUser(params: any) {
        return axios.post(`${GATEWAY_URL}/create-user`, params)
        .then((response) => {
            return response.data;
        });
    },

    async updateUser(key:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-user`, params)
        .then((response) => {
            return response.data;
        });
    },

    async checkUserByEmail(email: any) {
        return axios.get(`${GATEWAY_URL}/check-user`, {
            params: { email }
        })
        .then((response) => {
            return response.data;
        });
    },

    async checkUserByUsername(username: any) {
        return axios.get(`${GATEWAY_URL}/check-user`, {
            params: { username }
        })
        .then((response) => {
            return response.data;
        });
    },

    async getUser(id: any) {
        return axios.get(`${GATEWAY_URL}/get-user`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },

    async userList(loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/list-user`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },

    async listImpersonatableUsers(loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-impersonatable-users`, {
            params
        }).then((response) => {
            return response.data;
        });
    },

    async updateUserLanguage(params: any) {
        return axios.put(`${GATEWAY_URL}/update-user-language`, params)
        .then((response) => {
            return response.data;
        });
    }
}
